import encodiaImage from '@/assets/images/landing/scroll_512x512.webp'
import beginnersPortImage from '@/assets/images/EmporiumIcon_BeginnersPort.webp'
import slumberingBeachImage from '@/assets/images/EmporiumIcon_SlumberingBeach.webp'
import crystalWaveIslandImage from '@/assets/images/EmporiumIcon_CrystalWaveIsland.webp'
import starterKitImage from '@/assets/images/EmporiumIcon_StarterKit.webp'
import premiumSupportImage from '@/assets/images/EmporiumIcon_PremiumSupport.webp'
import novicePlanImage from '@/assets/images/EmporiumIcon_NovicePlan_243x256.webp'
import standardPlanImage from '@/assets/images/EmporiumIcon_StandardPlan_243x256.webp'
import veteranPlanImage from '@/assets/images/EmporiumIcon_VeteranPlan_243x256.webp'

// #721: 交易所の商品アイコンは thumbnailUrl ではなく productId から静的アセットに
// マップする（desktop ProductCard の codexSrc を共通化）。モバイルのリストカードも
// 同じ絵を出せるようにする。plan 系は具体的な variant（standard/veteran）を先に
// 判定する（従来は `plan` が先にマッチして全プランが novice アイコンになっていた）。
export function productIconFor(productId: string): string {
  if (productId.includes('plan:standard')) {
    return standardPlanImage
  }
  if (productId.includes('plan:veteran')) {
    return veteranPlanImage
  }
  if (productId.includes('plan')) {
    return novicePlanImage
  }
  if (productId.includes('beginnersPort')) {
    return beginnersPortImage
  }
  if (productId.includes('slumberingBeach')) {
    return slumberingBeachImage
  }
  if (productId.includes('crystalWaveIsland')) {
    return crystalWaveIslandImage
  }
  if (productId.includes('starterKit')) {
    return starterKitImage
  }
  if (productId.includes('premiumSupport')) {
    return premiumSupportImage
  }
  return encodiaImage
}
